<template>
  <JoszakiCard class="grid grid-cols-[auto_1fr] gap-2">
    <UserAvatar
      :image="$helpers.getProfilePictureThumbnailUrl(me.profilePhotoId)"
    />
    <div>
      <JoszakiTextArea
        v-model="answerBody"
        :show-error-msg="false"
        :placeholder="$t('questionPage.newAnswerCard.placeholder')"
      />
      <div class="flex max-md:flex-col max-md:gap-4 justify-between mt-4">
        <div v-if="attachedAnswer?.id">
          <p>{{ $t("questionPage.newAnswerCard.attachedAnswer") }}</p>
          <blockquote class="text-gray-500 ml-4 mb-4">
            {{ attachedAnswer.body }}
          </blockquote>
          <JoszakiButton
            type="error"
            icon-left="times"
            @click="clearAttachedAnswer"
          >
            {{ $t("questionPage.newAnswerCard.cancelAttach") }}
          </JoszakiButton>
        </div>
        <JoszakiButton
          v-else
          icon-left="paperclip"
          @click="questionStore.openModal(MODAL_ATTACH_ANSWER)"
        >
          {{ $t("questionPage.newAnswerCard.attachOldAnswer") }}
        </JoszakiButton>
        <JoszakiButton
          type="success"
          class="h-fit"
          icon-left="check"
          :disabled="answerBody.length < 5 || isSaving"
          :loading="isSaving"
          @click="submitAnswer"
        >
          {{ $t("questionPage.newAnswerCard.submit") }}
        </JoszakiButton>
      </div>
    </div>
  </JoszakiCard>
</template>

<script>
import { defineComponent } from "vue";
import { mapState } from "pinia";
import UserAvatar from "~/components/UserAvatar.vue";
import CREATE_ANSWER from "~/graphql/createAnswer.graphql";
import { useUserStore } from "~/stores/user";
import {
  MODAL_ATTACH_ANSWER,
  useQuestionStore,
} from "~/stores/question/question";

export default defineComponent({
  name: "CardNewAnswer",
  components: { UserAvatar },
  setup() {
    return {
      questionStore: useQuestionStore(),
      MODAL_ATTACH_ANSWER,
    };
  },
  data: () => {
    return {
      isSaving: false,
      answerBody: "",
    };
  },
  computed: {
    ...mapState(useUserStore, {
      me: "me",
    }),
    question() {
      return this.questionStore.question;
    },
    attachedAnswer() {
      return (
        this.questionStore.modalOutput("attachAnswerModal")?.answer ?? null
      );
    },
  },
  methods: {
    async submitAnswer() {
      console.info(
        "submitAnswer",
        this.answerBody,
        this.question,
        this.attachedAnswer
      );
      try {
        this.isSaving = true;
        await this.$mutate(CREATE_ANSWER, {
          questionId: Number(this.question.id),
          body: this.answerBody,
          linkedAnswerId: this.attachedAnswer?.id
            ? Number(this.attachedAnswer.id)
            : null,
        });

        this.answerBody = "";

        this.questionStore.clearAttachedAnswer();
        await this.questionStore.reloadQuestion();
        this.$joszaki.toast({
          message: this.$t("questionPage.newAnswerCard.success"),
          position: "is-top",
          type: "success",
        });
      } catch (e) {
        this.$joszaki.toast({
          message: this.$t("questionPage.newAnswerCard.error"),
          position: "is-top",
          type: "danger",
        });
      } finally {
        this.isSaving = false;
      }
    },
  },
});
</script>
